import { createSelector } from '@ngrx/store';

import { selectDetailState } from '@cdba/core/store/reducers';
import {
  CostComponentSplitState,
  DetailState,
} from '@cdba/core/store/reducers/detail/detail.reducer';
import {
  CostComponentSplitItem,
  CostComponentSplitType,
} from '@cdba/shared/models';

export const selectCostComponentSplitState = createSelector(
  selectDetailState,
  (state: DetailState): CostComponentSplitState | undefined =>
    state?.costComponentSplit
);

export const selectCostComponentSplitLoading = createSelector(
  selectCostComponentSplitState,
  (state: CostComponentSplitState): boolean | undefined => state?.loading
);

export const selectCostComponentSplitErrorMessage = createSelector(
  selectCostComponentSplitState,
  (state: CostComponentSplitState): string | undefined => state?.errorMessage
);

export const selectSelectedCostComponentSplitType = createSelector(
  selectCostComponentSplitState,
  (state: CostComponentSplitState): CostComponentSplitType | undefined =>
    state?.selectedSplitType
);

export const selectCostComponentSplitItemsOfSelectedSplitType = createSelector(
  selectCostComponentSplitState,
  (state: CostComponentSplitState): CostComponentSplitItem[] =>
    state?.items?.filter((item) => item.splitType === state.selectedSplitType)
);

export const selectCostComponentSplitSummary = createSelector(
  selectCostComponentSplitState,
  (state: CostComponentSplitState): CostComponentSplitItem[] =>
    state?.items?.filter(
      (item) => item.splitType === CostComponentSplitType.TOTAL
    )
);
